import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/k8s_training_web/k8s_training_web/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const InlineNotification = makeShortcode("InlineNotification");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`In this module, you download and install Istio.`}</p>
    <InlineNotification kind="warning" mdxType="InlineNotification">
      <p>{`Make sure you are in the `}<inlineCode parentName="p">{`training`}</inlineCode>{` directory!`}</p>
    </InlineNotification>
    <h2>{`🚀 TASK: Install Istio`}</h2>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Execute the following command to get the latest ISTIO source:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`
#Linux (Lab VM)
wget https://github.com/istio/istio/releases/download/1.27.3/istio-1.27.3-linux-amd64.tar.gz
tar xfvz istio-1.27.3-linux-amd64.tar.gz     

#Mac
wget https://github.com/istio/istio/releases/download/1.27.3/istio-1.27.3-osx.tar.gz
tar xfvz istio-1.27.3-osx.tar.gz

#Windows
Download https://github.com/istio/istio/releases/download/1.27.3/istio-1.27.3-win.zip
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Add the `}<inlineCode parentName="p">{`istioctl`}</inlineCode>{` client to your executables.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`export PATH=./istio-1.27.3/bin:$PATH
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Install Istio into the cluster:`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`istioctl install --set profile=demo
`}</code></pre>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-output"
          }}>{`> This will install the Istio 1.27.3 demo profile with ["Istio core" "Istiod" "Ingress gateways" "Egress gateways"] components into the cluster. Proceed? (y/N) y
> ✔ Istio core installed
>  Processing resources for Istiod. Waiting for Deployment/istio-system/istiod
> ...
> Making this installation the default for injection and validation.
> Thank you for installing Istio 1.17.  Please take a few minutes to tell us about your install/upgrade experience!  https://forms.gle/hMHGiwZHPU7UQRWe9
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Label the default namespace for automatic sidecar injection`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`kubectl label namespace default istio-injection=enabled                                                                                   
`}</code></pre>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-output"
          }}>{`> namespace/default labeled
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Check the labels`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`kubectl get ns --show-labels                                                                                                              
`}</code></pre>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-output"
          }}>{`> NAME                   STATUS   AGE   LABELS
> default                Active   66d   istio-injection=enabled
> istio-system           Active   62s   istio-injection=disabled,istio-operator-managed=Reconcile,operator.istio.io/    > component=Base,operator.istio.io/managed=Reconcile,operator.istio.io/version=1.4.0
> kube-node-lease        Active   66d   <none>
> kube-public            Active   66d   <none>
> kube-system            Active   66d   <none>
> kubernetes-dashboard   Active   66d   addonmanager.kubernetes.io/mode=Reconcile,kubernetes.io/minikube-addons=dashboard
`}</code></pre>
      </li>
    </ol>
    <h2>{`🚀 TASK: Install Addons`}</h2>
    <ol {...{
      "start": 6
    }}>
      <li parentName="ol">
        <p parentName="li">{`Run the following`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-shell",
            "metastring": "script",
            "script": true
          }}>{`kubectl apply -f ./istio-1.27.3/samples/addons/grafana.yaml
kubectl apply -f ./istio-1.27.3/samples/addons/prometheus.yaml
kubectl apply -f ./istio-1.27.3/samples/addons/jaeger.yaml
kubectl apply -f ./istio-1.27.3/samples/addons/kiali.yaml

`}</code></pre>
      </li>
    </ol>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">
        <p parentName="li">{`Ensure the corresponding pods are all in `}<strong parentName="p"><inlineCode parentName="strong">{`Running`}</inlineCode></strong>{` state before you continue.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`kubectl get pods -n istio-system
`}</code></pre>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-output"
          }}>{`> NAME                                    READY   STATUS    RESTARTS   AGE
> grafana-5dc4b4676c-dsdb5                1/1     Running   0          21m
> istio-egressgateway-5c7967cf9d-gnrpj    1/1     Running   0          21m
> istio-ingressgateway-676fbf789d-vldbf   1/1     Running   0          21m
> istio-tracing-8584b4d7f9-cj9p6          1/1     Running   0          21m
> istiod-55cd8455dd-4gq2j                 1/1     Running   0          23m
> kiali-6f457f5964-pvjw5                  1/1     Running   0          21m
> prometheus-7f54ff69cd-lf4xz             2/2     Running   0          21m
`}</code></pre>
      </li>
    </ol>
    <InlineNotification kind="warning" mdxType="InlineNotification">
      <p>{`If you get Image Inspection errors, please follow this solution:`}</p>
      <p><a parentName="p" {...{
          "href": "https://podman-desktop.io/docs/containers/registries#setting-up-a-registry-with-an-insecure-certificate"
        }}>{`https://podman-desktop.io/docs/containers/registries#setting-up-a-registry-with-an-insecure-certificate`}</a></p>
    </InlineNotification>
    <h2>{`🚀 TASK: Make Istio Ingress available`}</h2>
    <ol {...{
      "start": 7
    }}>
      <li parentName="ol">
        <p parentName="li">{`Patch the NodePort of the Istio Ingress to 30762. Like that we are sure that the HTTP port is fixed and known.`}</p>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-bash"
          }}>{`kubectl patch service -n istio-system istio-ingressgateway -p '{"spec": {"ports": [{"nodePort": 30762,"port":80,"name": "http2"}],"type": "NodePort"}}'
`}</code></pre>
        <pre parentName="li"><code parentName="pre" {...{
            "className": "language-output"
          }}>{`> service/istio-ingressgateway patched
`}</code></pre>
      </li>
    </ol>
    <p>{`​Before you continue, make sure all the pods are deployed and are either in the `}<strong parentName="p"><inlineCode parentName="strong">{`Running`}</inlineCode></strong>{` or `}<strong parentName="p"><inlineCode parentName="strong">{`Completed`}</inlineCode></strong>{` state. If they’re in `}<inlineCode parentName="p">{`Pending`}</inlineCode>{` or `}<inlineCode parentName="p">{`CrashLoopBackOff`}</inlineCode>{` state, wait a few minutes to let the deployment to settle.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      